import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'

const Wrapper = styled.section`
  margin-bottom: 65px;
`

const Card = styled.div`
  background: ${props => props.theme.colors.secondaryDark};
  padding-left: 40px;
  padding-bottom: 35px;
  margin-bottom: 120px;
`

const TitleBar = styled.div`
  background: ${props => props.theme.colors.background};
  transform: translateY(-50%);
  padding: 25px;
  display: flex;
  align-items: center;

  ${media.xs`
    flex-wrap: wrap;
  `}
`

const TitleText = styled.div`
  ${media.xs`
    width: 100%;
    margin-top: 15px;
  `}
`

const Image = styled.div`
  width: 75px;
  height: 75px;
  border-radius: 75px;
  background: url(${props => props.image}) center / cover no-repeat;
  flex-shrink: 0;
  margin-right: 30px;
`

const Name = styled.h4`
  color: ${props => props.theme.colors.primary};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  margin: 0;
`

const Title = styled.span`
  color: ${props => props.theme.colors.tones.light};
`

const Text = styled.p`
  padding-right: 30px;
  margin-top: -20px;
  margin-bottom: 30px;

  ${media.xs`
    margin-top: -40px;
  `}
`

const SoMe = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
`

const SoMeLink = styled.a`
  display: flex;
  width: 30px;
  height: 30px;
  background: ${props => props.theme.colors.tones.light};
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  transition: background 0.3s ${easing.easeOutCubic};

  &:hover {
    background: ${props => props.theme.colors.tones.dark};
  }
`

export default class ContactCards extends Component {
  render() {
    const { cards } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            {cards.map((card, index) => {
              return (
                <Col
                  sm={9}
                  smOffset={2}
                  lg={5}
                  lgOffset={index % 2 ? 0 : 1}
                  xl={4}
                  xlOffset={index % 2 ? 0 : 2}
                  key={index}
                >
                  <Card>
                    <TitleBar>
                      <Image image={card.image.sourceUrl} />
                      <TitleText>
                        <Name>{card.name}</Name>
                        <Title>{card.title}</Title>
                      </TitleText>
                    </TitleBar>
                    <Text dangerouslySetInnerHTML={{__html: card.text}} />
                    <SoMe>
                      {card.linkedin &&
                        <SoMeLink
                          href={card.linkedin}
                          target="_blank"
                        >
                          <svg
                            width="16"
                            height="14"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.09275 13.6753143h-3.1325V8.9696c0-1.2317143-.4891667-2.0725714-1.5675-2.0725714-.8241667 0-1.2825.5674285-1.4958333 1.1142857-.0791667.1962857-.0675.4688571-.0675.7431428v4.9208572H5.7260833s.0408334-8.3357143 0-9.0934286h3.1033334v1.4271429c.1833333-.624 1.175-1.5145715 2.7583333-1.5145715 1.9625 0 3.505 1.308 3.505 4.1245715v5.0562857zM2.58775 3.4436h-.01916667c-1 0-1.64916666-.69514286-1.64916666-1.57542857C.91941667.96988571 1.58775.28931429 2.60775.28931429c1.0183333 0 1.645.67885714 1.6658333 1.57628571 0 .88114286-.6475 1.578-1.6858333 1.578zM1.27691667 13.6753143H4.04025V4.5818857H1.27691667v9.0934286z"
                              fill="#FEFEFE"
                              fillRule="evenodd"
                            />
                          </svg>
                        </SoMeLink>
                      }
                      {card.facebook &&
                        <SoMeLink
                          href={card.facebook}
                          target="_blank"
                        >
                          <svg
                            width="6"
                            height="14"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.7583857 6.9865169h-1.779661V14H1.2823871V6.9865169H0v-2.464817h1.2823871V2.9266833C1.2823871 1.78607434 1.7860614 0 4.0027261 0L6 .0089887v2.3925249H4.5508475c-.237703 0-.571945.1277543-.571945.6718577v1.4506236h2.0150527l-.2355695 2.462522z"
                              fill="#FFF"
                            />
                          </svg>
                        </SoMeLink>
                      }
                      {card.website &&
                        <SoMeLink
                          href={card.website}
                          target="_blank"
                        >
                          <svg
                            width="12"
                            height="8"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.4193333 8l-2.16-7.968h2.364l1.068 4.68 1.284-4.68h2.1l1.296 4.668 1.068-4.668h1.968L9.2233333 8h-1.992l-1.392-4.848-1.356 4.848z"
                              fill="#FFF"
                              fillRule="evenodd"
                            />
                          </svg>
                        </SoMeLink>
                      }
                    </SoMe>
                  </Card>
                </Col>
              )
            })}
          </Row>
        </Container>

      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ContactCards/index.js